import { useSelector } from "react-redux";

import { isPaidUser } from "../utils/utils";
import { FREE_USER_LIMITS } from "../Components/NewDashboard/Commons/Constant";

export const useAllowedToContinue = (type) => {
  const { templateData = [], data: user } = useSelector((state) => state.auth);

  if (isPaidUser(user)) return true;

  let limitAchieved;

  switch (type) {
    case "clients":
      limitAchieved = useSelector((state) => state.clients.clientsTotalCount);
      break;

    case "projects":
      limitAchieved = useSelector((state) => state.project.prTotalCount);
      break;

    case "invoices":
      limitAchieved = useSelector((state) => state.invoices.invoiceTotalCount);
      break;

    case "proposalContractSentCount":
    case "statementDownloads":
    case "timeTrackingReportDownloads":
    case "invoiceSentCount":
      limitAchieved = user[type];
      break;

    case "templates":
      limitAchieved = templateData.length;
      break;

    case "clientContacts":
      const contacts = useSelector(
        (state) =>
          (state.clients.c_data_position &&
            state.clients.c_data_position.contacts) ||
          []
      );
      limitAchieved = contacts.length;
      break;

    case "contactsToEmail":
      const invoice = useSelector(
        (state) => state.invoices.selectedInvoiceData || {}
      );

      const proposalAndContractEmails = useSelector(
        (state) => state.proposalAndContract.selectedClientContacts || []
      );

      const invoiceContacts =
        (invoice.client_id && invoice.client_id.contacts) || [];

      limitAchieved =
        invoiceContacts.length || proposalAndContractEmails.length;
      break;

    case "proposalContracts":
      limitAchieved = useSelector(
        (state) => state.proposalAndContract.totalPcCount
      );
      break;

    case "contractClause":
      const { selectedData } = useSelector(
        (state) => state.proposalAndContract
      );

      limitAchieved = selectedData.add_clause.filter(
        (clause) => clause.required
      ).length;
      break;

    default:
      throw new Error("Unknown type");
  }

  return limitAchieved < FREE_USER_LIMITS[type];
};
